import React, { useEffect, useState } from "react";
import moment from "moment";
import columns from "../../columns/reports/signatureReport";
import SkeletonTable from "../../components/table/SkeletonTable";
import { GetSignatureReportApi } from "../../api/request/report";

const SignatureReport = () => {
  const [signatureList, setSignatureList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);

  const getSignatureList = async (page = 1) => {
    try {
      setIsLoading(true);
      const { data } = await GetSignatureReportApi({ page });
      if (data?.status) {
        setSignatureList(
          data?.data?.map((item) => {
            return {
              ...item,
              name: item?.user?.name,
              email: item?.user?.email,
              created_at: item?.created_at
                ? moment(item?.created_at).format("lll")
                : "",
              action: (
                <a
                  href={item?.path || "#"}
                  target={item?.path && "_blank"}
                  className="font-medium text-blue-500 underline"
                >
                  View
                </a>
              ),
            };
          })
        );
        setTotal(data?.total_record);
        setCurrentPage(page);
      }
      setIsLoading(false);
    } catch (error) {
      setSignatureList([]);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getSignatureList();
  }, []);

  const handleTableChange = (pagination) => {
    getSignatureList(pagination?.current);
  };

  return (
    <div className="border rounded-xl bg-white">
      <div class="py-5 px-4 flex items-center justify-between">
        <h2 class="font-semibold text-xl">Signature {total ? `(${total})` : null}</h2>
      </div>

      <div className="table-radius-0 text-light mb-4">
        <SkeletonTable
          columns={columns}
          data={signatureList}
          isLoading={isLoading}
          pagination={{
            current: currentPage,
            total: total,
            pageSize: 10,
            showSizeChanger: false,
          }}
          handleTableChange={handleTableChange}
        />
      </div>
    </div>
  );
};

export default SignatureReport;
